export const ON_DEMAND_EMAIL_SUBSCRIPTION_KEY = 'on_demand_email_subscription_';
export const ON_DEMAND_EMAIL_SUBSCRIPTION_DISMISS_DATE = 'on_demand_email_subscription_dismiss_date';
export const ON_DEMAND_INDICATOR_LAST_DISMISS_DATE = 'on_demand_indicator_dismiss_date_';
export const PLUGIN_ON_DEMAND_SHOW_RESULT_METRIC_KEY = 'PLUGIN_ON_DEMAND_SHOW_RESULT';
export const PLUGIN_ON_DEMAND_REDIRECT_METRIC_KEY = 'PLUGIN_ON_DEMAND_REDIRECT_RESULT';
